import { render, staticRenderFns } from "./ArtistTopTracks.vue?vue&type=template&id=89ef3c54&"
import script from "./ArtistTopTracks.vue?vue&type=script&lang=js&"
export * from "./ArtistTopTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports